









































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetHospitals } from "@/request/hdr";
import Copy from "@/components/copy.vue";
import Gailan from "./gailan.vue";
import Shetu from "./shetu.vue";
import HospitalTransfer from "../hospital-transfer.vue";
@Component({
  components: {
    Copy,
    Gailan,
    Shetu,
    HospitalTransfer,
  },
})
export default class KanbanYingxiang extends Vue {
  @Prop()
  private center: any;
  private hospitals: any[] = [];
  private canChooseHospitals: any[] = [];
  private ifShowHospitalTransfer: boolean = false;
  private selectedHospitals: any[] = [];

  private get selectedHospitalLabels() {
    if (this.selectedHospitals.length === 0) {
      return "全部机构";
    } else {
      const labels: any[] = [];
      this.selectedHospitals.forEach((h: any) => {
        labels.push(h["医院名称"]);
      });
      return labels.join("，");
    }
  }
  /**
   * @description 获取可选医院列表
   */
  private fetchHospitals() {
    const load = this.$loading({ text: "加载中" });
    return new Promise((resolve: any) => {
      GetHospitals(this).then((data: any) => {
        this.canChooseHospitals = data;
        load.close();
        resolve();
      });
    });
  }
  /**
   * @description 重置
   */
  private reset() {
    this.selectedHospitals = [];
  }
  /**
   * @description 统计机构改变
   */
  private hospitalChanged(ids) {
    ids.forEach((id: any) => {
      const targetHospital = this.canChooseHospitals.find((h: any) => {
        return h.hospital_id === id;
      });
      if (targetHospital) {
        this.selectedHospitals.push(targetHospital);
      }
    });
  }

  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchHospitals();
  }
}
